import React, {useState,useEffect,useContext,useCallback} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AuthContext } from "../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../config/api";

// COMPONENTES
import Grupo1 from "./components/grupo1";
import Grupo2 from "./components/grupo2";
import Grupo3 from "./components/grupo3";
import Grupo4 from "./components/grupo4";
import Grupo5 from "./components/grupo5";
import Grupo6 from "./components/grupo6";

const SeguimientoDos = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const { authFetch } = useContext(AuthContext);
    const [searchParams] = useSearchParams();

    const seguimientoUrl = searchParams.get("seguimiento");

    // ==========================
    // INFORMACIÓN
    // ==========================
    const [seguimientos, setSeguimientos] = useState([]);
    const [seguimientoSeleccionado, setSeguimientoSeleccionado] = useState(null);
    const [seguimiento, setSeguimiento] = useState(null);
    const [grupo, setGrupo] = useState(null);
    const [datos, setDatos] = useState([]);
    const [existeSeguimiento, setExisteSeguimiento] = useState(false);
    const [loading, setLoading] = useState(true);

    // ==========================
    // CREAR SEGUIMIENTO
    // =========================
    const [mes, setMes] = useState("");
    const [anio, setAnio] = useState( new Date().getFullYear());
    const [grupoSeleccionado, setGrupoSeleccionado] = useState("");
    const [seguimientoTexto, setSeguimientoTexto] = useState("");

    // ==========================
    // MENSAJES
    // ==========================
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const formatearMesAnio = (fecha) => {
    if (!fecha) return "";
    const [anio, mes] = fecha.split("-");

    const meses = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ];

    return `${meses[parseInt(mes) - 1]} de ${anio}`;

};

    const loadSeguimientos = useCallback(async () => {

        setLoading(true);
        setError("");

        try {

            const res = await authFetch(
                `${ENDPOINTS.get_seguimientos_programa}?id_informacion_general=${id}`
            );

            if (!res.success) {

                setError(res.message);
                setLoading(false);
                return;

            }

            const lista = res.data || [];

            setExisteSeguimiento(res.tieneSeguimientos);

            setSeguimientos(lista);

            if (lista.length === 0) {

                setSeguimiento(null);
                setSeguimientoSeleccionado(null);
                setGrupo(null);
                setDatos([]);
                setLoading(false);

                return;

            }

            let seguimientoInicial = lista[0];

            // Si viene un seguimiento específico desde Seguimiento General II
            if (seguimientoUrl) {

                const encontrado = lista.find(
                    item => String(item.id) === String(seguimientoUrl)
                );

                if (encontrado) {
                    seguimientoInicial = encontrado;
                }

            }

            setSeguimientoSeleccionado(seguimientoInicial.id);

        } catch (error) {

            console.error(error);

            setError("Error al cargar los seguimientos.");

            setLoading(false);

        }

    }, [id, authFetch, seguimientoUrl]);

    const loadInformacionSeguimiento = useCallback(async () => {

    if (!seguimientoSeleccionado) return;

    try {

        const res = await authFetch(

            `${ENDPOINTS.get_seguimiento_tecnico_dos}?id=${seguimientoSeleccionado}`

        );

        if (res.success) {

            setSeguimiento(res.data);

            setGrupo(Number(res.data.grupo));

        }

    } catch (error) {

        console.error(error);

    }

    }, [seguimientoSeleccionado, authFetch]);

    const loadDatos = useCallback(async () => {

        if (!seguimientoSeleccionado) {

            setDatos([]);
            setLoading(false);
            return;

        }

        try {

            const res = await authFetch(

                `${ENDPOINTS.get_datos_seguimiento_dos}?id_seguimiento_dos=${seguimientoSeleccionado}`

            );

            if (res.success) {

                setDatos(res.data || []);

            } else {

                setDatos([]);

            }

        } catch (error) {

            console.error(error);

            setDatos([]);

        }

        setLoading(false);

    }, [seguimientoSeleccionado, authFetch]);

    useEffect(() => {

        loadSeguimientos();

    }, [loadSeguimientos]);

    useEffect(() => {

        loadDatos();

    }, [loadDatos]);

    useEffect(() => {

    loadInformacionSeguimiento();

}, [loadInformacionSeguimiento]);

// ==========================
// CREAR SEGUIMIENTO
// ==========================
const crearSeguimiento = async () => {

    setError("");
    setSuccess("");

    if(!existeSeguimiento){

        if(!grupoSeleccionado){

            setError("Debe seleccionar un grupo.");
            return;

        }

        if(!seguimientoTexto.trim()){

            setError("Debe ingresar el seguimiento.");
            return;

        }

    }

    const body = {id_informacion_general: id,mes,anio };

    if (!existeSeguimiento) {

        body.grupo = grupoSeleccionado;
        body.seguimiento = seguimientoTexto;

    }

    if (!mes) {

        setError("Debe seleccionar el mes.");
        return;

    }

    try {

        const res = await authFetch(

            ENDPOINTS.create_seguimiento_tecnico_dos,

            {

                method: "POST",
                body: JSON.stringify(body)

            }

        );

        if (res.success) {

            setSuccess(res.message);
            await loadSeguimientos();

            setGrupoSeleccionado("");
            setSeguimientoTexto("");
            setMes("");

        }

        else {

            setError(res.message);

        }

    }

    catch (error) {

        console.error(error);
        setError("Error al crear el seguimiento.");

    }

};

// ==========================
// GUARDAR DATOS
// ==========================

const guardarDatos = async () => {

    setError("");
    setSuccess("");

    try {

        const res = await authFetch(

            ENDPOINTS.save_datos_seguimiento_dos,

            {

                method: "POST",
                body: JSON.stringify({

                    id_seguimiento_dos: seguimientoSeleccionado,
                    datos

                })

            }

        );

        if (res.success) {

            setSuccess(res.message);
            await loadDatos();

        }

        else {

            setError(res.message);

        }

    }

    catch (error) {

        console.error(error);

        setError("Error al guardar la información.");

    }

};

// ==========================
// CAMBIAR VALOR
// ==========================

const handleChange = (index, campo, valor) => {

    const nuevos = [...datos];
    nuevos[index][campo] = valor;

    if (grupo === 1) {

        const referencia = Number(nuevos[index].dato_referencia) || 0;
        const datoMes = Number(nuevos[index].dato_mes) || 0;

        nuevos[index].porcentaje_avance =
            referencia > 0
                ? Number(((datoMes / referencia) * 100).toFixed(2))
                : 0;

    }

    if (grupo === 3) {

        const requerido = Number(nuevos[index].personal_requerido) || 0;
        const contratado = Number(nuevos[index].personal_contratado) || 0;

        nuevos[index].indicador =
            requerido > 0
                ? Number(((contratado / requerido) * 100).toFixed(2))
                : 0;

    }

    if (grupo === 6) {

        const requerida =
            Number(nuevos[index].cantidad_requerida) || 0;

        const activa =
            Number(nuevos[index].cantidad_activa) || 0;

        nuevos[index].indicador_servicio =
            requerida > 0
                ? Number(
                    (
                        (activa / requerida) * 100
                    ).toFixed(2)
                )
                : 0;

    }

    setDatos(nuevos);

};

// ==========================
// AGREGAR FILA
// ==========================

const agregarFila = () => {

    let fila = {};

    switch (grupo) {

        case 1:

            fila = {

                pcb: "",
                dato_referencia: "",
                dato_mes: "",
                porcentaje_avance: 0

            };

            break;

        case 2:

            fila = {

                departamento: "",
                municipio: "",
                unidades_territoriales: "",
                descripcion_iniciativa: "",
                avance_enero: "",
                subcontratado: ""

            };

            break;

        case 3:

            fila = {

                proyecto: "",
                personal_requerido: "",
                personal_contratado: "",
                indicador: ""

            };

            break;

        case 4:

            fila = {

                etapa: "",
                num_apadrinados: ""

            };

            break;

        case 5:

            fila = {

                tipo_atencion: "",
                cantidad_atendida: ""

            };

            break;

        case 6:

            fila = {

                tipo_servicio: "",
                cantidad_requerida: "",
                cantidad_activa: "",
                indicador_servicio: ""

            };

            break;

        default:

            fila = {};

    }

    setDatos([...datos, fila]);

};

// ==========================
// ELIMINAR FILA
// ==========================
const eliminarFila = (index) => {
    setDatos( datos.filter((_, i) => i !== index));
};

// ==========================
// RENDER GRUPO
// ==========================

const renderGrupo = () => {
    const props = {
        datos,
        handleChange,
        eliminarFila
    };

    switch (grupo) {

        case 1:
            return <Grupo1 {...props} />;

        case 2:
            return <Grupo2 {...props} />;

        case 3:
            return <Grupo3 {...props} />;

        case 4:
            return <Grupo4 {...props} />;

        case 5:
            return <Grupo5 {...props} />;

        case 6:
            return <Grupo6 {...props} />;

        default:

            return (

                <div className="alert alert-warning">
                    El programa no tiene un grupo configurado.
                </div>

            );

    }

};
if (loading) {

    return (

        <div className="text-center mt-5">

            Cargando...

        </div>

    );

}

return (

    <div className="container mt-4">

        {/* HEADER */}

        <div className="d-flex justify-content-between align-items-center mb-4">

            <h3>Seguimiento Técnico II</h3>
            <button className="btn btn-outline-pink" onClick={() => navigate(-1)}>
                <i className="bi bi-arrow-left me-2"></i>
                Volver
            </button>

        </div>

        {/* INFORMACIÓN */}

        {

            seguimiento &&

            <div className="card mb-4">

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3">

                            <strong>Programa</strong>
                            <br />
                            {seguimiento.program_name}

                        </div>

                        <div className="col-md-3">

                            <strong>Número de contrato</strong>
                            <br />
                            {seguimiento.contrato_convenio}

                        </div>

                        <div className="col-md-3">

                            <strong>Contratante</strong>
                            <br />
                            {seguimiento.contratante}

                        </div>

                        <div className="col-md-3">

                            <strong>Mes</strong>
                            <br />
                            {formatearMesAnio(seguimiento.mes_año)}

                        </div>

                    </div>

                </div>

            </div>

        }

        {/* MENSAJES */}

        {

            error &&

            <div className="alert alert-danger">

                {error}

            </div>

        }

        {

            success &&

            <div className="alert alert-success">

                {success}

            </div>

        }

        {
            existeSeguimiento && (

                <div className="card mb-4">

                    <div className="card-header">
                        Seguimientos registrados
                    </div>

                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-6">

                                <label className="form-label">
                                    Seleccione el seguimiento
                                </label>

                                <select
                                    className="form-select"
                                    value={seguimientoSeleccionado || ""}
                                   onChange={(e) => {setSeguimientoSeleccionado(Number(e.target.value));}}
                                >

                                    {
                                        seguimientos.map((item) => (

                                            <option
                                                key={item.id}
                                                value={item.id}
                                            >

                                                {item.descripcion}

                                            </option>

                                        ))
                                    }

                                </select>

                            </div>

                        </div>

                    </div>

                </div>

            )
        }

        {/* CREAR SEGUIMIENTO */}


        <div className="card mb-4">

            <div className="card-header">
                Crear Seguimiento Técnico
            </div>

            <div className="card-body">

                <div className="row">
                    {/* mes */}
                    <div className="col-md-2">

                        <label>Mes</label>
                        <select className="form-select"
                            value={mes}
                            onChange={(e)=>
                                setMes(
                                    e.target.value
                                )
                            }
                        >

                            <option value="" hidden>Seleccione</option>
                            <option value="1">Enero</option>
                            <option value="2">Febrero</option>
                            <option value="3">Marzo</option>
                            <option value="4">Abril</option>
                            <option value="5">Mayo</option>
                            <option value="6">Junio</option>
                            <option value="7">Julio</option>
                            <option value="8">Agosto</option>
                            <option value="9">Septiembre</option>
                            <option value="10">Octubre</option>
                            <option value="11">Noviembre</option>
                            <option value="12">Diciembre</option>

                        </select>

                    </div>
                    {/*año  */}
                    <div className="col-md-2">

                        <label>Año</label>
                        <input
                            type="number"
                            className="form-control"
                            value={anio}
                            onChange={(e)=>
                                setAnio(
                                    e.target.value
                                )
                            }
                        />

                    </div>
                    {/* grupo */}
                    {!existeSeguimiento ? (

                        <div className="col-md-3">

                            <label>Grupo</label>

                            <select
                                className="form-select"
                                value={grupoSeleccionado}
                                onChange={(e) => setGrupoSeleccionado(e.target.value)}
                            >

                                <option value="">Seleccione</option>

                                <option value="1">Grupo 1 - PCB</option>
                                <option value="2">Grupo 2 - Cobertura territorial</option>
                                <option value="3">Grupo 3 - Personal</option>
                                <option value="4">Grupo 4 - Apadrinamiento</option>
                                <option value="5">Grupo 5 - Tipo atención</option>
                                <option value="6">Grupo 6 - Tipo servicio</option>

                            </select>

                        </div>

                        ) : (

                        <div className="col-md-3">

                            <label>Grupo</label>

                            <input
                                className="form-control"
                                value={`Grupo ${grupo}`}
                                disabled
                            />

                        </div>

                        )
                    }
                    {/* seguimiento */}
                    {
                        !existeSeguimiento ? (

                            <div className="col-md-3">

                                <label>Seguimiento</label>

                                <input
                                    className="form-control"
                                    value={seguimientoTexto}
                                    onChange={(e) => setSeguimientoTexto(e.target.value)}
                                />

                            </div>

                        ) : (

                            <div className="col-md-3">

                                <label>Seguimiento</label>

                                <input
                                    className="form-control"
                                    value={seguimiento?.seguimiento || ""}
                                    disabled
                                />

                            </div>

                        )
                    }

                    <div className="col-md-2 d-flex align-items-end">
                        <button className="btn btn-success" onClick={crearSeguimiento}>Crear seguimiento</button>
                    </div>

                </div>

            </div>

        </div>


        {

    existeSeguimiento &&

    <>

        <div className="mb-3">

            <button className="btn btn-success me-2" onClick={agregarFila}>
                <i className="bi bi-plus-circle me-1"></i>
                Agregar fila
            </button>

            <button className="btn btn-primary" onClick={guardarDatos}>
                <i className="bi bi-save me-1"></i>
                Guardar
            </button>

        </div>

        <div className="card">

            <div className="card-body">

                <h5 className="mb-3">Información Grupo {grupo}</h5>
                {renderGrupo()}

            </div>

        </div>

    </>

}
    </div>

);

};

export default SeguimientoDos;